export const initVideoPlayer = () => {
    const videos = document.querySelectorAll<HTMLVideoElement>(
        '[data-selector="grid-video"]',
    );
    if (!videos.length) return;

    const observeAndInitVideo = (video: HTMLVideoElement) => {
        if (!(video instanceof HTMLVideoElement)) return;

        const loadAndPlay = () => {
            video.load();

            video
                .play()
                .then(() => {})
                .catch((err) => {
                    if (err.name !== "AbortError") {
                        console.warn("Video play failed:", err);
                    }
                });

            setupToggleButton(video);
        };

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadAndPlay();
                        video.removeAttribute("data-load");
                        observer.unobserve(video);
                    }
                });
            });

            observer.observe(video);
        } else {
            loadAndPlay();
        }
    };

    const setupToggleButton = (video: HTMLVideoElement) => {
        const container = video.closest("div");
        if (!container) return;

        const oldToggle = container.querySelector<HTMLButtonElement>(
            '[data-selector="video-toggle"]',
        );
        if (!oldToggle) return;

        const newToggle = oldToggle.cloneNode(true) as HTMLButtonElement;
        oldToggle.replaceWith(newToggle);

        const playLabel = newToggle.getAttribute("data-play-label") || "Play";
        const pauseLabel =
            newToggle.getAttribute("data-pause-label") || "Pause";

        const updateLabel = (playing: boolean) => {
            newToggle.textContent = playing ? pauseLabel : playLabel;
            newToggle.setAttribute(
                "aria-label",
                playing ? pauseLabel : playLabel,
            );
        };

        newToggle.addEventListener("click", () => {
            const isPlaying =
                !video.paused && !video.ended && video.readyState > 2;
            const willPlay = !isPlaying;

            if (willPlay) {
                video.play().catch((err) => {
                    if (err.name !== "AbortError") {
                        console.warn("Play failed:", err);
                    }
                });
            } else {
                video.pause();
            }

            updateLabel(willPlay);
        });

        updateLabel(!video.paused);
    };

    videos.forEach((video) => {
        const isLazy = video.hasAttribute("data-load");
        if (isLazy) {
            observeAndInitVideo(video);
        } else {
            setupToggleButton(video);
        }
    });
};
